/* GUINOT — interactive behaviours
   Generic, section-agnostic handlers only.
   Header and product-page handlers live INSIDE their own section files.
   - Tabs (data-tabs)         — used by product-tabs homepage section
   - Fade-in (data-fade)      — used across the site
*/

(function () {
  'use strict';

  /* ---------- Tabs (data-tabs) ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-panel') !== key;
          });
        });
      });
    });
  }

  /* ---------- Fade-in observer ---------- */
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-fade]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Init ---------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initTabs();
    initFadeIn();
  });
})();
